import ContactForm from "@/components/ContactForm";
import SEO from "@/components/SEO";
import { Mail, Globe } from "lucide-react";

export default function Kontakt() {
  return (
    <>
      <SEO
        title="Kontakt – PINE Systems Direktkontakt für allgemeine Anfragen"
        description="Direktkontakt für allgemeine Anfragen, individuelle Entwicklungen, Kooperationen und besondere Projekte mit PINE Systems."
      />

      {/* HERO */}
      <section className="relative border-b border-[rgba(255,255,255,0.08)] overflow-hidden">
        <div className="absolute inset-0 grid-overlay opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-12 md:pt-36 md:pb-20">
          <div className="overline" data-testid="kontakt-eyebrow">Direktkontakt</div>
          <h1
            className="font-display text-4xl sm:text-5xl md:text-6xl uppercase mt-4 max-w-5xl leading-[1.05]"
            data-testid="kontakt-headline"
          >
            Sprechen Sie <span className="text-[#18E096]">uns an.</span>
          </h1>
          <p className="text-[#AEB7B7] mt-6 max-w-3xl text-base md:text-lg leading-relaxed">
            Sie haben eine allgemeine Anfrage, eine besondere Projektidee oder möchten prüfen,
            ob PINE Systems zu Ihrem Unternehmen passt? Dann schreiben Sie uns.
          </p>
          <p className="text-[#AEB7B7] mt-4 max-w-3xl text-base leading-relaxed">
            Nicht jede Anfrage beginnt mit einer konkreten Fläche. Vielleicht geht es um
            individuelle Entwicklungen, Kooperationen, digitale Markenräume, Hospitality-Projekte,
            Standortideen oder eine besondere Herausforderung in Ihrem Unternehmen.
          </p>
          <p className="text-[#AEB7B7] mt-4 max-w-3xl text-base leading-relaxed">
            Nutzen Sie das Kontaktformular für alle Anfragen, die nicht direkt über
            Standortprüfung, Gründerpfad, Dev-Programm oder Sales Partner laufen.
          </p>
        </div>
      </section>

      {/* CONTACT BLOCK */}
      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 space-y-8">
            <div>
              <div className="overline mb-3">Direktkontakt</div>
              <a
                href="mailto:partner@pinexs.de"
                className="flex items-center gap-3 text-white hover:text-[#18E096] transition-colors text-lg"
                data-testid="contact-email"
              >
                <Mail size={20} strokeWidth={1.5} /> partner@pinexs.de
              </a>
              <a
                href="https://www.pinexs.de"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-3 text-white hover:text-[#18E096] transition-colors text-lg mt-2"
                data-testid="contact-website"
              >
                <Globe size={20} strokeWidth={1.5} /> www.pinexs.de
              </a>
            </div>

            <div
              className="border border-[#18E096]/40 bg-[#0B0F10] p-6"
              data-testid="kontakt-hinweis"
            >
              <div className="overline text-[#18E096] mb-3">Sonstige Anfragen?</div>
              <h3 className="font-display text-xl uppercase leading-tight">
                Individuelle Projekte und Kooperationen.
              </h3>
              <p className="text-[#AEB7B7] text-sm mt-4 leading-relaxed">
                Individuelle Entwicklungen für Ihr Unternehmen, besondere Projekte, Kooperationen
                oder Fragen zu PINE Systems? Zögern Sie nicht, uns anzusprechen.
              </p>
              <div className="mt-5 text-sm text-[#F5F7F7] space-y-1">
                <div>
                  <a href="mailto:partner@pinexs.de" className="hover:text-[#18E096]">
                    partner@pinexs.de
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.pinexs.de"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-[#18E096]"
                  >
                    www.pinexs.de
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
